import { usefulLinkApi as api } from './useful-link.api';

export const usefulLinkActions = {
  async getUsefulLinks({ commit }, payload) {
    try {
      commit('GET_USEFUL_LINKS_LOADING');
      const response = await api.getUsefulLinks(payload);
      commit('GET_USEFUL_LINKS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_USEFUL_LINKS_ERROR', error.response);
    }
  },
  async getUsefulLink({ commit }, id) {
    try {
      commit('GET_USEFUL_LINK_LOADING');

      const response = await api.getUsefulLink(id);

      commit('GET_USEFUL_LINK_SUCCESS', response.data);
    } catch (error) {
      commit('GET_USEFUL_LINK_ERROR', error.response);
    }
  },
  async addUsefulLink({ commit }, body) {
    try {
      commit('ADD_USEFUL_LINK_LOADING');

      const response = await api.addUsefulLink(body);

      commit('ADD_USEFUL_LINK_SUCCESS', response.data);
    } catch (error) {
      commit('ADD_USEFUL_LINK_ERROR', error.response);
    }
  },
  async deleteUsefulLink({ commit }, id) {
    try {
      commit('DELETE_USEFUL_LINK_LOADING');

      const response = await api.deleteUsefulLink(id);

      commit('DELETE_USEFUL_LINK_SUCCESS', response.data);
    } catch (error) {
      commit('DELETE_USEFUL_LINK_ERROR', error.response);
    }
  },
  async updateUsefulLink({ commit }, { id, body }) {
    try {
      commit('UPDATE_USEFUL_LINK_LOADING');

      const response = await api.updateUsefulLink(id, body);

      commit('UPDATE_USEFUL_LINK_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_USEFUL_LINK_ERROR', error.response);
    }
  },
};
